import { ref as E, toRef as f } from "vue";
import p from "./ghl-ui.es735.js";
import { warn as R } from "./ghl-ui.es899.js";
import y from "./ghl-ui.es741.js";
import { call as s } from "./ghl-ui.es939.js";
function h(o, r) {
  const a = p(() => {
    for (const e of o.columns)
      if (e.type === "expand")
        return process.env.NODE_ENV !== "production" && !e.renderExpand && R("data-table", "column with type `expand` has no `renderExpand` prop."), e.renderExpand;
  }), t = p(() => {
    let e;
    for (const n of o.columns)
      if (n.type === "expand") {
        e = n.expandable;
        break;
      }
    return e;
  }), l = E(o.defaultExpandAll ? a != null && a.value ? (() => {
    const e = [];
    return r.value.treeNodes.forEach((n) => {
      var d;
      !((d = t.value) === null || d === void 0) && d.call(t, n.rawNode) && e.push(n.key);
    }), e;
  })() : r.value.getNonLeafKeys() : o.defaultExpandedRowKeys), c = f(o, "expandedRowKeys"), u = f(o, "stickyExpandedRows"), x = y(c, l);
  function i(e) {
    const {
      onUpdateExpandedRowKeys: n,
      "onUpdate:expandedRowKeys": d
    } = o;
    n && s(n, e), d && s(d, e), l.value = e;
  }
  return {
    stickyExpandedRowsRef: u,
    mergedExpandedRowKeysRef: x,
    renderExpandRef: a,
    expandableRef: t,
    doUpdateExpandedRowKeys: i
  };
}
export {
  h as useExpand
};
